import { forwardRef, type ComponentProps } from 'react';
import { css, cx } from '@linaria/atomic';
import { theme } from '@frontend/theme';
import type { TextareaProps } from '../../atoms';
import { AutoGrowTextarea, Textarea } from '../../atoms';
import type { BasicFormFieldProps, ExtraFieldProps } from '../../layouts';
import { FieldLayout } from '../../layouts';

const textareaFieldStyle1 = css`
  padding: 8px 8px 8px 16px;

  textarea {
    height: 100%;
    padding-right: 8px;
    resize: none;
    ::-webkit-scrollbar {
      width: 6px;
      height: 6px;
    }
    ::-webkit-scrollbar-thumb {
      background-color: ${theme.colors.neutral20};
      border-radius: ${theme.borderRadius.small};
    }
  }
`;

type TextareaFieldProps = BasicFormFieldProps<'text'> &
  Pick<ExtraFieldProps, 'containerCss'> &
  TextareaProps & {
    autoGrow?: [number, number];
    height?: number;
    max?: number;
    size?: number;
    color?: string;
  };

export const TextareaField = forwardRef<HTMLDivElement, TextareaFieldProps>(
  ({ autoGrow, height = 120, max, className, ...rest }, ref) => {
    const shouldAutogrow = Array.isArray(autoGrow);
    return (
      <FieldLayout
        //this fieldLayout takes all kind of form field types which can't intersect with eachother... We need to fix that
        className={cx(textareaFieldStyle1, className)}
        style={{ height: shouldAutogrow ? 'auto' : height }}
        hasPadding={false}
        //TODO: this might be able to be improved. But this type cast just makes sure the field prop is any of the correct field types
        {...(rest as ComponentProps<typeof FieldLayout>)}
        field={(shouldAutogrow ? AutoGrowTextarea : Textarea) as ComponentProps<typeof FieldLayout>['field']}
        fieldComponentProps={shouldAutogrow ? { minRows: autoGrow![0], maxRows: autoGrow![1] } : undefined}
        ref={ref}
      />
    );
  }
);
TextareaField.displayName = 'TextareaField';
